import { JsonUtility } from '../app/jsonUtility.js';

export class AppSiteTemplateData {
    appSite: string = '';
    templatesJson: string = '';
    metadataJson: string | null = null;
    // The resolved root AppFile for THIS AppSite (e.g. "SetTimeAppFile"). Mirrors ConfigOCI's
    // per-AppSite artifactAppFile so the client can resolve the entry template for an AppSite
    // reached via a dynamic-AppSite redirect (the flat top-level AppFile is the request AppSite only).
    appFile: string | null = null;

    constructor(appSite: string, templatesJson: string, metadataJson: string | null = null, appFile: string | null = null) {
        this.appSite = appSite;
        this.templatesJson = templatesJson;
        this.metadataJson = metadataJson;
        this.appFile = appFile;
    }

    toJson(): string {
        let result = '{"templates":' + this.templatesJson;

        if (this.appFile) {
            result += ',"appFile":"' + JsonUtility.escapeJson(this.appFile) + '"';
        }

        if (this.metadataJson) {
            // Emit the built metadata as an OPAQUE artifact string (escaped), so ConfigClient stores/
            // serves it verbatim like ConfigOCI's Metadata artifact layer; the loader owns decoding it.
            result += ',"metadata":"' + JsonUtility.escapeJson(this.metadataJson) + '"';
        }

        result += '}';
        return result;
    }
}
